import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../components/Layout/MainLayout";
import { useEffect, useState } from "react";
import { useApiCall } from "../services/api";
import TermAgreement from "../components/models/TermAgreement";
import { resetState, setAuthLogin } from "../redux/auth/loginSlice";
import { handleRouteNav } from "../utils";
import { resetData } from "../redux/auth/loginDataSlice";
import { resetCartState } from "../redux/auth/cartRefreshSlice";
import ChatBox from "../components/models/ChatBox";
import { useGlobalModal } from "../context/SuccessModalProvider";

const PrivateRoute = ({ children, role, showMainLayout = true }) => {
  const { postApi } = useApiCall();
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [backButton, setBackButton] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const userRoleId = useSelector((state) => state.auth.role_id);
  const user_id = useSelector((state) => state.auth.user_id);
  const customer_id = useSelector((state) => state.auth.customer_id);
  const is_customer = useSelector((state) => state.auth.is_customer);
  const is_agree_terms = useSelector((state) => state.auth.is_agree_terms);
  const allowedRole = Array.isArray(role) ? role : [role];
  const isBlocked = useSelector((state) => state.auth.is_blocked);
  const { profileRefreshKey, refreshKey } = useSelector(
    (state) => state.cartRefresh,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const allData = useSelector((state) => state.auth.user);
  const { showPopup } = useGlobalModal();

  const location = useLocation();

  useEffect(() => {
    return () => {
      setTitle(null);
      setDescription(null);
      setBackButton(false);
    };
  }, [navigate]);

  const userId = {
    customer_id: customer_id,
  };
  const fetchProfile = async () => {
    const res = await postApi(
      is_customer ? "customer/get-profile" : "user/get-profile",
      is_customer ? userId : { user_id },
    );

    if (res?.status) {
      dispatch(setAuthLogin(res.data));
    } else {
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            {res?.message || "Session expired. Please login again."}
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      navigate(handleRouteNav("/login", userRoleId));
      dispatch(resetState());
      dispatch(resetData());
      dispatch(resetCartState());
    }
  };

  useEffect(() => {
    if (is_customer && is_agree_terms == 0) {
      setIsModalOpen(true);
    }
    if (user_id) {
      fetchProfile();
    }
  }, [profileRefreshKey, refreshKey]);

  if (isBlocked && !location.pathname?.includes("account-block")) {
    return <Navigate to={"/account-block"} replace />;
  } else if (!user_id) {
    return <Navigate to={"/login"} replace />;
  } else if (!allowedRole.includes(userRoleId)) {
    return <Navigate to={"/unauthorized"} replace />;
  }

  return showMainLayout ? (
    <MainLayout title={title} description={description} backButton={backButton}>
      <Outlet context={{ setTitle, setDescription, setBackButton }} />
      <TermAgreement
        role_id={userRoleId}
        customer_id={customer_id}
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      ></TermAgreement>
      {is_customer && (
        <img
          onClick={() => {
            setIsChatOpen(true);
          }}
          className="cursor-pointer fixed right-4 bottom-[15px] h-[55px] w-[55px]"
          src="/assets/icons/chatIcon.svg"
        ></img>
      )}
      <ChatBox
        allData={allData}
        role_id={userRoleId}
        customer_id={customer_id}
        isOpen={isChatOpen}
        closeModal={() => setIsChatOpen(false)}
      ></ChatBox>
    </MainLayout>
  ) : (
    <Outlet context={{ setTitle, setDescription, setBackButton }} />
  );
};

export default PrivateRoute;
